<script setup lang="ts">
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import Button from 'primevue/button';
import { useUserState } from '@/stores/useUserState';

const { t } = useI18n();

const props = withDefaults(defineProps<{ message?: string }>(), {
  message: 'Please log in or sign up to trade.',
});

const displayMessage = computed(() => props.message || t('pleaseLogInOrSignUpToTrade'));
const userState = useUserState();

function login() {
  const domain = window.location.host.replace(/^[^.]+\./g, '');
  window.location.href = `https://www.${domain}/sso/Login?forwardTo=100`;
}

function signup() {
  const domain = window.location.host.replace(/^[^.]+\./g, '');
  window.location.href = `https://www.${domain}/Universal/Application?eventContract=T`;
}
</script>

<template>
  <div
    v-if="!userState.authenticated"
    role="alert"
    class="flex items-center justify-between gap-4 rounded-2xl bg-accent-subtle px-5 py-4"
  >
    <p class="text-sm text-on-surface">{{ displayMessage }}</p>
    <nav aria-label="Account actions" class="flex shrink-0 gap-2">
      <Button
        :label="t('logIn')"
        severity="primary"
        outlined
        size="small"
        :aria-label="t('logInToAccount')"
        @click="login"
      />
      <Button
        :label="t('openAccount')"
        severity="primary"
        size="small"
        :aria-label="t('openNewAccount')"
        data-type="cta"
        data-cta-btn="a_open_accou_6"
        :pt="{ label: { 'data-type': 'cta' } }"
        @click="signup"
      />
    </nav>
  </div>
</template>
